import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_3 = { class: "table-responsive p-0" }
const _hoisted_4 = { class: "table align-items-center mb-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Entregador"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Veículo Atual"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-secondary opacity-7" })
  ])
], -1)
const _hoisted_6 = { class: "d-flex px-2 py-1" }
const _hoisted_7 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_8 = { class: "mb-0 text-sm" }
const _hoisted_9 = { class: "text-xs text-secondary mb-0" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Atualizando", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onUpdate:modelValue", "onChange"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Selecione um Veículo", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: "nenhum" }, "Nenhum Veículo", -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "align-middle text-center text-sm" }
const _hoisted_23 = { class: "form-check form-switch" }
const _hoisted_24 = ["onChange", "onUpdate:modelValue"]
const _hoisted_25 = {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}
const _hoisted_26 = { class: "text-sm" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-eye text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-trash text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.rows, (operadores) => {
              return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h6", _hoisted_8, _toDisplayString(operadores.nome_completo), 1),
                      _createElementVNode("p", _hoisted_9, _toDisplayString(operadores.brand), 1)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_10, [
                  (!operadores.editingOperador)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!operadores.veiculo)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, " NENHUM VEÍCULO ALOCADO "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                              (operadores.is_update)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_16))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(operadores.veiculo.marca), 1)
                            ])),
                        _createElementVNode("i", {
                          class: "fas fa-user-edit text-secondary",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (operadores.editingOperador = true)
                        }, null, 8, _hoisted_17)
                      ], 64))
                    : _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 1,
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => ((operadores.veiculo_id) = $event),
                        onChange: ($event: any) => ($setup.salvarUnico(operadores))
                      }, [
                        _hoisted_19,
                        _hoisted_20,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.veiculos, (m) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: m.id,
                            value: m.id
                          }, _toDisplayString(m.marca), 9, _hoisted_21))
                        }), 128))
                      ], 40, _hoisted_18)), [
                        [_vModelSelect, operadores.veiculo_id]
                      ])
                ]),
                _createElementVNode("td", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "flexSwitchCheckDefault",
                      onChange: ($event: any) => ($setup.setStatus(operadores)),
                      "onUpdate:modelValue": ($event: any) => ((operadores.ativo) = $event)
                    }, null, 40, _hoisted_24), [
                      [_vModelCheckbox, operadores.ativo]
                    ]),
                    _createElementVNode("label", _hoisted_25, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge badge-sm", {'bg-success': operadores.ativo, 'bg-danger': !operadores.ativo}])
                      }, _toDisplayString(operadores.ativo ? 'Ativo' : 'Inativo'), 3)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_26, [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: ($event: any) => ($setup.getUnico(operadores.id)),
                    "data-bs-toggle": "tooltip",
                    "data-bs-original-title": "Preview product"
                  }, _hoisted_29, 8, _hoisted_27),
                  _hoisted_30,
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: ($event: any) => ($setup.deleteUnico(operadores.id)),
                    "data-bs-toggle": "tooltip",
                    "data-bs-original-title": "Delete product"
                  }, _hoisted_33, 8, _hoisted_31)
                ])
              ]))
            }), 256))
          ])
        ])
      ])
    ])
  ]))
}